{
  "pt": {
    "overview": {
      "actions": {
        "select_decision": "Selecione a decisão",
        "select_installment": "Selecione a parcela",
        "select_point_list": "Selecionar lista de pontos",
        "select_survey": "Selecione a pesquisa"
      },
      "table": {
        "labels": {
          "category": "Categoria",
          "level": "Nível",
          "status": "Status"
        }
      }
    }
  }
}